export type DepartmentDto = {
  id?: number;
  name?: string;
  children?: DepartmentDto[];
  connected?: DepartmentDto;
  position: number;
};

export type DepartmentModel = {
  id?: number;
  name: string;
  children: DepartmentModel[];
  connected: DepartmentModel | null;
  position: number;
  parentId?: number;
};

export function mapDepartmentModelToDto(model: DepartmentModel): DepartmentDto {
  return {
    id: model.id,
    name: model.name,
    children: model.children.map(mapDepartmentModelToDto),
    position: model.position,
  };
}

export function mapDepartmentDtoToModel(dto: DepartmentDto, parentId?: number): DepartmentModel {
  return {
    id: dto.id,
    name: dto.name,
    children: (dto.children || [])
      .filter((childEntry) => !!childEntry)
      .map((childEntry) => mapDepartmentDtoToModel(childEntry, dto.id)),
    connected: dto.connected && mapDepartmentDtoToModel(dto.connected),
    position: dto.position,
    parentId: parentId,
  };
}

export namespace Department {
  export const OVERALL = 'all';

  export function getNestedChildren(department: DepartmentModel): DepartmentModel[] {
    const nested: DepartmentModel[] = [];
    const stack = [...department.children];

    while (stack.length) {
      const child = stack.pop()!;
      nested.push(child);

      if (child.children?.length) {
        stack.push(...child.children);
      }
    }

    return nested;
  }
}
